import Form from './form';
import FormItem from './form-item';

Form.FormItem = FormItem;

export default Form;
